import React from "react";

const Impressum = () => {
  return (
    <main className="video-page">
      <section className="section" style={{ paddingTop: "clamp(7rem, 12vw, 10rem)" }}>
        <div className="container-narrow prose-body">
          <h1 style={{ fontSize: "clamp(2.2rem, 4vw, 3rem)", marginBottom: "2rem" }}>Impressum</h1>

          <p style={{ marginBottom: 0 }}>
            <strong>Dr. Ing. Luca Pizzimbone</strong>
            <br />
            Homburger Str. 31
            <br />
            61184 Karben
            <br />
            Deutschland
          </p>

          <p style={{ marginTop: "1.5rem" }}>
            Mail:{" "}
            <a href="mailto:info@nonlocalfield.io">info@nonlocalfield.io</a>
          </p>

          <p style={{ marginTop: "1.5rem" }}>
            The European Commission provides a platform for online dispute
            resolution (ODR), which you can find here:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
            . We are not obliged or willing to participate in dispute resolution
            proceedings before a consumer arbitration board.
          </p>

          <h2 style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", margin: "2.5rem 0 1.25rem" }}>
            Health &amp; Legal Disclaimer
          </h2>
          <p>
            Pursuant to the decision of the German Federal Constitutional Court (BVerfG), 1 BvR 784/03,
            the offerings of Nonlocal Field Harmonization (NLFH) and energetic spaceholding serve
            exclusively to support innate self-regulation. They do not constitute medical,
            alternative-health (Heilpraktiker), or psychotherapeutic treatment, and do not replace
            diagnosis or treatment by a licensed physician, surgeon, or psychotherapist. No promises of
            cure or specific health outcomes are made, and no medical diagnoses are performed. Please do
            not delay, interrupt, alter, or discontinue any ongoing medical treatment, therapy, or
            prescribed medication without first consulting your attending doctor.
          </p>
          <p style={{ marginTop: "1.5rem" }}>
            Within this boundary, NLFH's sole purpose is to cultivate an environment of somatic safety,
            heart coherence, and spacious awareness — supporting, never replacing, your relationship with
            conventional medical and mental-health care, and with the licensed professionals who provide it.
          </p>
        </div>
      </section>
    </main>
  );
};

export default Impressum;
